import React, { useContext, useEffect, useState } from "react";
import Header from "./header";
import Footer from "./footer";
import Counter from "./countertext";
import PricingPlan from "./legalnoticepp";
import { Link } from 'react-router-dom';
import Testimonials from "./Testimonial";
import WhatsAppScrollButton from "./floatingwhatsApp";
import CircularScrollProgress from "./Circularprogress";
import { PartenerSheepDeedService } from "../services/parternshipservice";
import CitySelector from "./User/CitySelectore";
import { ServicesContext } from "../services/ServicesContext";
import { handleRazorpayPayment } from "../services/handlePayment";
import AuthUser from "../services/AuthUser";
import { useNavigate } from "react-router-dom";



function Legalnoticereply() {


    useEffect(() => {
        const storedUser = localStorage.getItem("user");
        if (storedUser) {
          const parsedUser = JSON.parse(storedUser);
          setNewData((prevData) => ({
            ...prevData,
            user_name: parsedUser.name || "",
            user_email_address: parsedUser.email || "",
            user_phone_number: parsedUser.mobile || "",
            user_location: parsedUser.city || "",
          }));
        }
      }, []);

    const [activeQuestion, setActiveQuestion] = useState(null);
     const { http, token } = AuthUser();
   const navigate = useNavigate();
    const toggleQuestion = (questionId) => {
        setActiveQuestion((prev) => (prev === questionId ? null : questionId));
    };

    const [isFormVisible, setFormVisible] = useState(false);

    const toggleForm = () => {
        setFormVisible(!isFormVisible);
    };


    const [receivedData, setReceivedData] = useState(null);

    const handleDataFromChild = (data) => {
        console.log("Data received from child:", data);
        setReceivedData(data);
    };
    const [newData, setNewData] = useState({
        user_name: '', user_email_address: '', user_phone_number: '', user_location: ''
    })

    const [errors, setErrors] = useState({});

   const { services, loading, error } = useContext(ServicesContext);  
   if (loading) {
      return <div>Loading...</div>;  // Show loading state while fetching data
  }

  if (error) {
       return <div>{error}</div> // Show error state if there was an issue fetching data
  }
   const service = services.find(s => s.service_id === 19);

    const validateForm = () => {
        const newErrors = {};

        // Name validation
        if (!newData.user_name.trim()) {
            newErrors.user_name = 'Name is required.';
        } else if (!/^[a-zA-Z\s]+$/.test(newData.user_name)) {
            newErrors.user_name = '*Name should only contain letters and spaces.';
        }

        // Email validation
        if (!newData.user_email_address.trim()) {
            newErrors.user_email_address = 'Email is required.';
        } else if (!/\S+@\S+\.\S+/.test(newData.user_email_address)) {
            newErrors.user_email_address = 'Enter a valid email address.';
        }

        // Phone number validation
        if (!newData.user_phone_number.trim()) {
            newErrors.user_phone_number = 'number is required.';
          } else if (!/^\d{10}$/.test(newData.user_phone_number)) {
            newErrors.user_phone_number = 'Enter a valid 10-digit contact number.';
          }
   

        // Category validation
        if (!newData.user_location
        ) {
            newErrors.user_location
                = 'Please select a category.';
        }

        setErrors(newErrors);
        return Object.keys(newErrors).length === 0; // Return true if no errors
    };



        const formPutPartenshipdeed = async (e) => {
             e.preventDefault();

                 // ✅ Check if user is logged in
         //   if (!token) {
    //      alert("Please log in to continue.");
    //      localStorage.setItem("redirectAfterLogin", window.location.pathname); // ⬅️ Save current path
    //     navigate('/login'); // 👈 Use this if you're using React Router
    //     return;
    //  }
             if (!validateForm()) return;
           
           localStorage.setItem("bookingData", JSON.stringify(newData));

      // Navigate to checkout
      navigate('/checkout', {
         state: {
            service: service,

         }
      });
              
           };


    return (

        // legalclaimhelp

        <>



            <div className="hero-area10 header-background">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-8">
                            <div className="title title2 ">
                                <div className="headding-shape aniamtion-key-2">
                                    <img src="assets/img/shapes/hero8-shape2.svg" alt="" />
                                </div>
                                <h1 className="sk-text-color">Legal Notice Reply</h1>
                                <p className="pdrl-text">Start Legal Notice Reply with Only <span className="text-color"> Rs.{service?.price}/- </span><span>(Final Price, No Hidden Costs)</span>   </p>
                                <p className="pd-text">Received a legal notice? Stay calm—Dm2Legal is here to help! Our experts assist in drafting, reviewing, and responding to legal notices, ensuring your reply is legally sound and safeguarding your rights. Contact us today for reliable support!</p>
                                <div className="btn-group">

                                    <Link to="/contactus" className="theme-btn-3 btn-color">
                                        Get Started <span><i className="fa-solid fa-arrow-right"></i></span>
                                    </Link>

                                </div>
                                <div className="space30"></div>

                                <div className="banner">
                                    <img src="assets/icons/banner.svg" alt="" srcset="" />
                                </div>
                            </div>

                        </div>

                        <div className="col-lg-4">
                            <img className="hero9-shape3 aniamtion-key-1" src="assets/img/shapes/hero9-shape.svg" alt="" />
                            <div className="contact3-form-all">
                                <div className="hadding7">
                                    <h3>Book Service Now </h3>
                                    <p className="pdrl-text"> Start with Only at Rs.{service?.price}/- <br/><span>(Final Price, No Hidden Costs)</span>  </p>
                                    
                                    {/* <p style={{ fontSize: "12px" }}>Further, the additional charges may apply with your mutual consent.</p> */}
                                </div>
                                <form action="#">
                                    <div className="form-input-all">
                                        <div className="form-input-box">
                                            <div className="row">
                                                <div className="col-md-12">
                                                    <div className="input-single6">
                                                        <div className="">
                                                            <label for="">Name<span className="red">*</span></label>{errors.user_name && <p className="error-text">{errors.user_name}</p>}
                                                            <input type="text" placeholder="Enter your Name" value={newData.user_name} onChange={(e) => setNewData({ ...newData, user_name: e.target.value })} />
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-md-12">
                                                    <div className="input-single6">
                                                        <div className="">
                                                            <label for="">Email Address<span className="red">*</span></label> {errors.user_email_address && <p className="error-text">{errors.user_email_address}</p>}
                                                            <input type="email" placeholder="Enter your Email Address" value={newData.user_email_address} onChange={(e) => setNewData({ ...newData, user_email_address: e.target.value })} />
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-md-12">
                                                    <div className="input-single6">
                                                        <div className="">
                                                            <label for="">Contact Number<span className="red">*</span></label>{errors.user_phone_number && <p className="error-text">{errors.user_phone_number}</p>}
                                                            <input type="number" placeholder="Enter your Contact Number" value={newData.user_phone_number} onChange={(e) => setNewData({ ...newData, user_phone_number: e.target.value })} />
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-12">
                                                <CitySelector
                                          newData={newData}
                                          setNewData={setNewData}
                                          fieldKey="user_location"
                                          errors={errors}
                                       />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="space20"></div>
                                        <div className="btn-group-2">
                                            <a className="theme-btn-3" href="#" onClick={formPutPartenshipdeed}>Proceed now <span><i className="fa-solid fa-arrow-right"></i></span></a>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>

                    </div>
                </div>
            </div>

            <div className="space20"></div>

            <div className="home4-counters">

                <div className="container">
                    <div className="space80"></div>
                    <div className="row">
                        <div className="space80"></div>
                        <div className="col-md-6 col-sm-6">

                            {/* <PricingPlan title="GENERAL" text="Preferable in general matters where examination of documents is not required." price="551"
                                onSubmit={handleDataFromChild} /> */}
                        </div>
                        <div className="col-md-6 col-sm-6">


                            {/* <PricingPlan title="DETAILED" text="Preferable in matters where examination of documents is required." price="2251"
                                onSubmit={handleDataFromChild} /> */}



                        </div>
                        <div className="col-lg-12">
                            <p className="pd-text">Delaying your response to a legal notice or failing to reply can lead to serious legal consequences, and you may lose the opportunity to resolve the dispute amicably. Save time and increase your chances of a favorable resolution by consulting with our experts, who will handle all your legal reply-related matters. It’s important to take legal notices seriously and send a proper legal response to avoid potential legal issues. While responding to a legal notice is not mandatory, it’s strongly recommended to ensure the other party cannot claim you failed to comply with the notice’s requirements. Contact our experienced legal professionals for expert advice, and let them manage all your legal replies.</p>
                        </div>
                    </div>
                    <div className="space40"></div>

                    <div className="row">
                        <div className="col-lg-12">
                            <div className="hadding7">

                                <h2 className="text-center">How to apply</h2>
                                <div className="space20"></div>
                                <img src="assets/img/images/legal251-how-to-apply.png" />
                            </div>
                        </div>
                        <div className="space20"></div>
                    </div>

                </div>
            </div>

            <div className="space40"></div>

            <div className="service-binifits9 "  >

                <div className="container">
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="hadding7">
                                <h2 className="text-center">Benefits </h2>
                                <div className="service-binifits-boxs">
                                    <div className="row">
                                        <div className="col-md-4">
                                            <div className="single-boxs bg-box">
                                                &nbsp;&nbsp;
                                                <div className="icon">
                                                    <p> <span><img className="arow" src="assets/image/arow-01.svg" alt="" /></span>
                                                        Resolution of Dispute</p>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-md-4">
                                            <div className="single-boxs bg-box">
                                                &nbsp;&nbsp;
                                                <div className="icon">
                                                    <p> <span><img className="arow" src="assets/image/arow-01.svg" alt="" /></span>
                                                        Amicable Settlement</p>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-md-4">
                                            <div className="single-boxs bg-box">
                                                &nbsp;&nbsp;
                                                <div className="icon">
                                                    <p> <span><img className="arow" src="assets/image/arow-01.svg" alt="" /></span>
                                                        Saves Time & Money</p>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-md-4">
                                            <div className="single-boxs bg-box">
                                                &nbsp;&nbsp;
                                                <div className="icon">
                                                    <p> <span><img className="arow" src="assets/image/arow-01.svg" alt="" /></span>
                                                        Saves from Non-compliance</p>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-md-4">
                                            <div className="single-boxs bg-box">
                                                &nbsp;&nbsp;
                                                <div className="icon">
                                                    <p> <span><img className="arow" src="assets/image/arow-01.svg" alt="" /></span>
                                                        Evidence of Communication</p>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-md-4">
                                            <div className="single-boxs bg-box">
                                                &nbsp;&nbsp;
                                                <div className="icon">
                                                    <p> <span><img className="arow" src="assets/image/arow-01.svg" alt="" /></span>
                                                        Chance to Deny Allegation & Claims</p>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-md-4">
                                            <div className="single-boxs bg-box">
                                                &nbsp;&nbsp;
                                                <div className="icon">
                                                    <p> <span><img className="arow" src="assets/image/arow-01.svg" alt="" /></span>
                                                        Legal Actions Against the Sender</p>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-md-4">
                                            <div className="single-boxs bg-box">
                                                &nbsp;&nbsp;
                                                <div className="icon">
                                                    <p> <span><img className="arow" src="assets/image/arow-01.svg" alt="" /></span>
                                                        Counter-Reaction

                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-md-4">
                                            <div className="single-boxs bg-box">
                                                &nbsp;&nbsp;
                                                <div className="icon">
                                                    <p> <span><img className="arow" src="assets/image/arow-01.svg" alt="" /></span>
                                                        Resolve Personal Conflicts out of the court

                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-md-4">
                                            <div className="single-boxs bg-box">
                                                &nbsp;&nbsp;
                                                <div className="icon">
                                                    <p> <span><img className="arow" src="assets/image/arow-01.svg" alt="" /></span>
                                                        Avoid Legal Actions</p>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-md-4">
                                            <div className="single-boxs bg-box">
                                                &nbsp;&nbsp;
                                                <div className="icon">
                                                    <p> <span><img className="arow" src="assets/image/arow-01.svg" alt="" /></span>
                                                        Admissible in Court</p>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-md-4">
                                            <div className="single-boxs bg-box">
                                                &nbsp;&nbsp;
                                                <div className="icon">
                                                    <p> <span><img className="arow" src="assets/image/arow-01.svg" alt="" /></span>
                                                        Opportunity to Present Your Side</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="space30"></div>
                    </div>
                </div>
            </div>
            <div className="space40"></div>

            <div className="service-binifits9 sp0 last-section" id="service2">
                <div className="space50"></div>
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12 ">
                            <div className="hadding7">
                                <h2 className="text-center">Registration Process </h2>
                                <div className="partnership-deade-section">
                                    <div className="space40"></div>
                                    <ul className="disc-list">
                                        <li>
                                            <h3>Step 1 <span><img className="arow" src="assets/image/blackarow.svg" alt="" /></span></h3>
                                            <span>Our legal experts will carefully review all the documents you submit to minimize the risk of incorrect or misleading information, ensuring a smooth process.</span>
                                            <svg className="pointer">
                                                <path d="M6.25,1.25L11.25,11.25L1.25,11.25L6.25,1.25Z" />
                                            </svg>
                                        </li>
                                        <li>
                                            <h3>Step 2 <span><img className="arow" src="assets/image/blackarow.svg" alt="" /></span></h3>
                                            <span>Our top lawyers are here to assist you with document requirements and licensing needs.</span>
                                            <svg className="pointer">
                                                <path d="M6.25,1.25L11.25,11.25L1.25,11.25L6.25,1.25Z" />
                                            </svg>
                                        </li>
                                        <li>
                                            <h3>Step 3 <span><img className="arow" src="assets/image/blackarow.svg" alt="" /></span></h3>
                                            <span>The lawyers will proceed with your documents to prepare your Legal Reply.</span>
                                            <svg className="pointer">
                                                <path d="M6.25,1.25L11.25,11.25L1.25,11.25L6.25,1.25Z" />
                                            </svg>
                                        </li>
                                        <li>
                                            <h3>Step 4 <span><img className="arow" src="assets/image/blackarow.svg" alt="" /></span></h3>
                                            <span>Once the documents you provided are successfully verified, our lawyers will prepare the Legal Reply on your behalf. You can then download it directly from our website or the Dm2Legal app.</span>
                                            <svg className="pointer">
                                                <path d="M6.25,1.25L11.25,11.25L1.25,11.25L6.25,1.25Z" />
                                            </svg>
                                        </li>
                                        <li>
                                            <h3>Step 5 <span><img className="arow" src="assets/image/done.svg" alt="" /></span></h3>
                                            <span>It is advisable to wait until our expert contacts you to inform you that your Legal Reply has been completed.</span>
                                            <svg className="pointer">
                                                <path d="M6.25,1.25L11.25,11.25L1.25,11.25L6.25,1.25Z" />
                                            </svg>
                                        </li>
                                    </ul>

                                </div>
                            </div>
                            <div className="space50"></div>
                        </div>
                    </div>

                </div>
            </div>

            <div className="tes7 ">
                <div className="container">
                    <div className="row">
                        <div className="col-12">
                            <div className="faq-items" id="masonry-grid">
                                <div className="mesonry-item general single-price-list">
                                    <div className="faqs inner-faq">
                                        <h2 className="text-center">FREQUENTLY ASKED QUESTIONS</h2>
                                        <div className="space30"></div>


                                        <div id="general">


                                            <div className="single-faq">
                                                <h2
                                                    className={`faq-heading font-f-3 weight-700 ${activeQuestion === 1 ? '' : 'collapsed'
                                                        }`}
                                                    id="faq-heading1"
                                                    onClick={() => toggleQuestion(1)}
                                                >
                                                    Q1.What should one do first after receiving a legal notice?
                                                    <span>
                                                        {activeQuestion === 1 ? (
                                                            <img src="assets/img/icons/plus-3.svg" className="minusicon" alt="" />
                                                        ) : (
                                                            <img src="assets/img/icons/plus-2.svg" className="plusicon" alt="" />


                                                        )}
                                                    </span>

                                                </h2>
                                                <div
                                                    id="collapse1"
                                                    className={`accordion-collapse collapse ${activeQuestion === 1 ? 'show' : ''
                                                        }`}
                                                >
                                                    <p className="font-f-3 weight-500">
                                                        The first thing to do after receiving a legal notice is to carefully read and understand its contents. It's advisable to consult with a lawyer to assess the situation and determine the appropriate course of action.                                                    </p>
                                                </div>
                                            </div>
                                            <div className="single-faq">
                                                <h2
                                                    className={`faq-heading font-f-3 weight-700 ${activeQuestion === 2 ? '' : 'collapsed'
                                                        }`}
                                                    id="faq-heading1"
                                                    onClick={() => toggleQuestion(2)}
                                                >
                                                    Q2. What happens if I don't respond to a legal notice?
                                                    <span>
                                                        {activeQuestion === 2 ? (
                                                            <img src="assets/img/icons/plus-3.svg" className="minusicon" alt="" />
                                                        ) : (
                                                            <img src="assets/img/icons/plus-2.svg" className="plusicon" alt="" />


                                                        )}
                                                    </span>
                                                </h2>
                                                <div
                                                    id="collapse1"
                                                    className={`accordion-collapse collapse ${activeQuestion === 2 ? 'show' : ''
                                                        }`}
                                                >
                                                    <p className="font-f-3 weight-500">
                                                        If you don't reply to a legal notice, the sender may take legal action against you. This could lead to a lawsuit, court proceedings, or other legal consequences, depending on the nature of the notice.                                                    </p>
                                                </div>
                                            </div>
                                            <div className="single-faq">
                                                <h2
                                                    className={`faq-heading font-f-3 weight-700 ${activeQuestion === 3 ? '' : 'collapsed'
                                                        }`}
                                                    id="faq-heading1"
                                                    onClick={() => toggleQuestion(3)}
                                                >
                                                    Q3. What is a Legal Reply?
                                                    <span>
                                                        {activeQuestion === 3 ? (
                                                            <img src="assets/img/icons/plus-3.svg" className="minusicon" alt="" />
                                                        ) : (
                                                            <img src="assets/img/icons/plus-2.svg" className="plusicon" alt="" />


                                                        )}
                                                    </span>
                                                </h2>
                                                <div
                                                    id="collapse1"
                                                    className={`accordion-collapse collapse ${activeQuestion === 3 ? 'show' : ''
                                                        }`}
                                                >
                                                    <p className="font-f-3 weight-500">
                                                        A Legal Reply is a formal document written by a party, typically in response to a declaration or, in some cases, an obligation. It serves as a reply to a legal notice or claim. </p>
                                                </div>
                                            </div>
                                            <div className="single-faq">
                                                <h2
                                                    className={`faq-heading font-f-3 weight-700 ${activeQuestion === 4 ? '' : 'collapsed'
                                                        }`}
                                                    id="faq-heading1"
                                                    onClick={() => toggleQuestion(4)}
                                                >
                                                    Q4. What key points should one consider while drafting a legal reply?
                                                    <span>
                                                        {activeQuestion === 4 ? (
                                                            <img src="assets/img/icons/plus-3.svg" className="minusicon" alt="" />
                                                        ) : (
                                                            <img src="assets/img/icons/plus-2.svg" className="plusicon" alt="" />


                                                        )}
                                                    </span>
                                                </h2>
                                                <div
                                                    id="collapse1"
                                                    className={`accordion-collapse collapse ${activeQuestion === 4 ? 'show' : ''
                                                        }`}
                                                >
                                                    <p className="font-f-3 weight-500">After receiving a legal notice, you should consider the following points when preparing a Legal Reply:</p>
                                                    <ul>
                                                        <li>Acknowledge receipt: Mention that you received the legal notice.</li>
                                                        <li>Be clear and concise: Address each point raised in the notice.</li>
                                                        <li>Provide facts and evidence: Support your response with relevant documents and facts.</li>
                                                        <li>Maintain professionalism: Use formal language and tone.</li>
                                                        <li>Follow legal provisions: Ensure your reply adheres to the applicable laws and regulations.</li>
                                                        <li>Consult a lawyer: It’s often advisable to seek professional legal help before sending a reply.</li>

                                                    </ul>
                                                </div>
                                            </div>
                                            <div className="single-faq">
                                                <h2
                                                    className={`faq-heading font-f-3 weight-700 ${activeQuestion === 5 ? '' : 'collapsed'
                                                        }`}
                                                    id="faq-heading1"
                                                    onClick={() => toggleQuestion(5)}
                                                >
                                                    Q5. Who can send and draft a Legal Reply?
                                                    <span>
                                                        {activeQuestion === 5 ? (
                                                            <img src="assets/img/icons/plus-3.svg" className="minusicon" alt="" />
                                                        ) : (
                                                            <img src="assets/img/icons/plus-2.svg" className="plusicon" alt="" />


                                                        )}
                                                    </span>
                                                </h2>
                                                <div
                                                    id="collapse1"
                                                    className={`accordion-collapse collapse ${activeQuestion === 5 ? 'show' : ''
                                                        }`}
                                                >
                                                    <p className="font-f-3 weight-500">
                                                        Individual or Representative: The person receiving the legal notice can send a reply, either personally or through an authorized representative.<br />Individual or Representative: The person receiving the legal notice can send a reply, either personally or through an authorized representative.
                                                    </p>
                                                </div>
                                            </div>
                                            <div className="single-faq">
                                                <h2
                                                    className={`faq-heading font-f-3 weight-700 ${activeQuestion === 6 ? '' : 'collapsed'
                                                        }`}
                                                    id="faq-heading1"
                                                    onClick={() => toggleQuestion(6)}
                                                >
                                                    Q6. What is the time period to send a legal reply to a notice?
                                                    <span>
                                                        {activeQuestion === 6 ? (
                                                            <img src="assets/img/icons/plus-3.svg" className="minusicon" alt="" />
                                                        ) : (
                                                            <img src="assets/img/icons/plus-2.svg" className="plusicon" alt="" />


                                                        )}
                                                    </span>
                                                </h2>
                                                <div
                                                    id="collapse1"
                                                    className={`accordion-collapse collapse ${activeQuestion === 6 ? 'show' : ''
                                                        }`}
                                                >
                                                    <p className="font-f-3 weight-500">
                                                        The legal reply should typically be sent within 7 to 15 days from the date of receiving the notice. However, the exact time may vary depending on the nature of the notice and the terms mentioned in it.
                                                    </p>
                                                </div>
                                            </div>
                                            <div className="single-faq">
                                                <h2
                                                    className={`faq-heading font-f-3 weight-700 ${activeQuestion === 7 ? '' : 'collapsed'
                                                        }`}
                                                    id="faq-heading1"
                                                    onClick={() => toggleQuestion(7)}
                                                >
                                                    Q7. What are the situations in which a legal notice is served?
                                                    <span>
                                                        {activeQuestion === 7 ? (
                                                            <img src="assets/img/icons/plus-3.svg" className="minusicon" alt="" />
                                                        ) : (
                                                            <img src="assets/img/icons/plus-2.svg" className="plusicon" alt="" />


                                                        )}
                                                    </span>
                                                </h2>
                                                <div
                                                    id="collapse1"
                                                    className={`accordion-collapse collapse ${activeQuestion === 7 ? 'show' : ''
                                                        }`}
                                                >
                                                    <p className="font-f-3 weight-500">A legal notice is served in cases like:</p>
                                                    <ul>
                                                        <li>Breach of contract or agreement</li>
                                                        <li>Disputes over property or ownership</li>
                                                        <li>Non-payment of dues or loans</li>
                                                        <li>Defamation or false accusations</li>
                                                        <li>Employment issues like wrongful termination</li>
                                                        <li>Consumer complaints or dissatisfaction</li>

                                                    </ul>
                                                </div>
                                            </div>

                                            <div className="single-faq">
                                                <h2
                                                    className={`faq-heading font-f-3 weight-700 ${activeQuestion === 8 ? '' : 'collapsed'
                                                        }`}
                                                    id="faq-heading1"
                                                    onClick={() => toggleQuestion(8)}
                                                >
                                                    Q8. What are common errors people make when sending a Legal Reply?
                                                    <span>
                                                        {activeQuestion === 8 ? (
                                                            <img src="assets/img/icons/plus-3.svg" className="minusicon" alt="" />
                                                        ) : (
                                                            <img src="assets/img/icons/plus-2.svg" className="plusicon" alt="" />


                                                        )}
                                                    </span>
                                                </h2>
                                                <div
                                                    id="collapse1"
                                                    className={`accordion-collapse collapse ${activeQuestion === 8 ? 'show' : ''
                                                        }`}
                                                >
                                                    <p className="font-f-3 weight-500">Common mistakes include:</p>
                                                    <li>Ignoring the notice without responding on time</li>
                                                    <li>Not addressing all points raised in the legal notice</li>
                                                    <li>Being emotional or hostile in the reply</li>
                                                    <li>Missing deadlines for sending the reply</li>
                                                    <li>Failing to provide proper evidence to support the response</li>
                                                    <li>Not seeking professional legal advice before drafting the reply</li>
                                                </div>
                                            </div>

                                            <div className="single-faq">
                                                <h2
                                                    className={`faq-heading font-f-3 weight-700 ${activeQuestion === 9 ? '' : 'collapsed'
                                                        }`}
                                                    id="faq-heading1"
                                                    onClick={() => toggleQuestion(9)}
                                                >
                                                    Q9. What are the advantages of sending a Legal Reply?
                                                    <span>
                                                        {activeQuestion === 9 ? (
                                                            <img src="assets/img/icons/plus-3.svg" className="minusicon" alt="" />
                                                        ) : (
                                                            <img src="assets/img/icons/plus-2.svg" className="plusicon" alt="" />


                                                        )}
                                                    </span>
                                                </h2>
                                                <div
                                                    id="collapse1"
                                                    className={`accordion-collapse collapse ${activeQuestion === 9 ? 'show' : ''
                                                        }`}
                                                >
                                                    <p className="font-f-3 weight-500">
                                                        Sending a legal reply:<br />

                                                        Protects your rights and interests by addressing the allegations or claims made.<br />
                                                        Prevents legal escalation by showing your willingness to resolve matters without litigation.<br />
                                                        Helps avoid default judgments by ensuring timely response.<br />
                                                        Strengthens your case in the event of court proceedings.<br />
                                                        Clarifies misunderstandings and may lead to settlement or resolution.                                                    </p>
                                                </div>
                                            </div>

                                            <div className="single-faq">
                                                <h2
                                                    className={`faq-heading font-f-3 weight-700 ${activeQuestion === 10 ? '' : 'collapsed'
                                                        }`}
                                                    id="faq-heading1"
                                                    onClick={() => toggleQuestion(10)}
                                                >
                                                    Q10. Who should be the recipient of a Legal Reply?
                                                    <span>
                                                        {activeQuestion === 10 ? (
                                                            <img src="assets/img/icons/plus-3.svg" className="minusicon" alt="" />
                                                        ) : (
                                                            <img src="assets/img/icons/plus-2.svg" className="plusicon" alt="" />


                                                        )}
                                                    </span>
                                                </h2>
                                                <div
                                                    id="collapse1"
                                                    className={`accordion-collapse collapse ${activeQuestion === 10 ? 'show' : ''
                                                        }`}
                                                >
                                                    <p className="font-f-3 weight-500">
                                                        A legal reply should be addressed to:<br/>

                                                        The sender of the legal notice, typically mentioned in the notice.<br/>
                                                        If applicable, the legal representative or lawyer acting on behalf of the sender.<br/>
                                                        Ensure the correct name, address, and designation are mentioned to avoid confusion.
                                                    </p>
                                                </div>
                                            </div>








                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
            <Testimonials />



            <div className="sp2 last-section">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-7 m-auto text-center">
                            <div className="hadding7">

                                <h2>Why Choose Us?</h2>
                            </div>
                        </div>
                    </div>
                    <div className="space30"></div>
                    <div className="row">
                        <div className="col-lg-6">
                            <div className="service6-box">
                                <div className="">
                                    <div className="service-box-icon">
                                        <p>1</p>
                                    </div>
                                </div>
                                <div className="hadding6">
                                    <h4><span><img className="arow" src="assets/image/icons/growth.svg" alt="" /></span><a href="single-service-1.html" >Growth & Improvement</a></h4>
                                    <p>We are committed to continuous growth and improvement. To us, growth is the fundamental principle of life, and we strive to achieve it. We understand the significance of business growth and its importance to you.</p>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-6">
                            <div className="service6-box">
                                <div className="">
                                    <div className="service-box-icon">
                                        <p>2</p>
                                    </div>
                                </div>
                                <div className="hadding6">
                                    <h4><span><img className="arow" src="assets/image/icons/support.svg" alt="" /></span><a href="single-service-1.html" >Support & Availability</a></h4>
                                    <p>We understand how even a small problem or query can cause frustration. That's why we are always available to provide support and resolve any issues you may have, whenever they arise.</p>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-6">
                            <div className="service6-box">
                                <div className="">
                                    <div className="service-box-icon">
                                        <p>3</p>
                                    </div>
                                </div>
                                <div className="hadding6">
                                    <h4><span><img className="arow" src="assets/image/icons/team.svg" alt="" /></span><a href="single-service-1.html" >Experienced Team</a></h4>
                                    <p>Our team consists of experienced professionals who prioritize professionalism and customer satisfaction above all else. Each member is passionate about their respective field and dedicated to delivering the best service.</p>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-6">
                            <div className="service6-box">
                                <div className="">
                                    <div className="service-box-icon">
                                        <p>4</p>
                                    </div>
                                </div>
                                <div className="hadding6">
                                    <h4><span><img className="arow" src="assets/image/icons/focus.svg" alt="" /></span><a href="single-service-1.html" >Focus</a></h4>
                                    <p>We treat every task with the utmost importance. Our team members remain dedicated and focused on addressing even the smallest needs and requirements of our clients.</p>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-6">
                            <div className="service6-box">
                                <div className="">
                                    <div className="service-box-icon">
                                        <p>5</p>
                                    </div>
                                </div>
                                <div className="hadding6">
                                    <h4><span><img className="arow" src="assets/image/icons/value.svg" alt="" /></span><a href="single-service-1.html" >Value for Money</a></h4>
                                    <p>We understand the value of your hard-earned money. That's why we ensure that every penny you invest with us is utilized in the most effective way, delivering the best value for your investment.</p>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-6">
                            <div className="service6-box">
                                <div className="">
                                    <div className="service-box-icon">
                                        <p>6</p>
                                    </div>
                                </div>
                                <div className="hadding6">
                                    <h4><span><img className="arow" src="assets/image/icons/care.svg" alt="" /></span><a href="single-service-1.html" >Care & Regards</a></h4>
                                    <p>We consider you a part of our family, and your challenges and successes are our own. Your interests are our priority, and we are dedicated to fulfilling them with the utmost care and attention.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="space80"></div>

            <WhatsAppScrollButton />

            <Footer />

            <CircularScrollProgress />





        </>
    );
}


export default Legalnoticereply;